module.exports = __webpack_public_path__ + "static/media/count50_326.9b655c9e.png";